const CommonTab = ({
  key,
  setTab,
  tab,
  value,
  label,
  length,
  textClassName,
}) => {
  return (
    <div
      key={key}
      onClick={() => setTab(value)}
      className={`${
        length > 1 && "max-w-[50%]"
      } w-full text-lg cursor-pointer relative ${
        tab === value
          ? "text-transaction-text dark:text-base-light-white common-tab-bottom after:bg-main-color"
          : "text-transaction-text dark:text-base-light-white"
      } font-medium`}
    >
      <p
        className={`${textClassName} whitespace-nowrap text-center pb-[12px]`}
      >{`${label}`}</p>
    </div>
  );
};

export default CommonTab;
